{
  "tabs": {
    "chat": "Chat",
    "reminders": "Pengingat",
    "calendar": "Kalender",
    "settings": "Pengaturan"
  },
  "common": {
    "cancel": "Batal",
    "save": "Simpan",
    "confirm": "Konfirmasi",
    "delete": "Hapus",
    "back": "Kembali",
    "close": "Tutup",
    "edit": "Edit",
    "search": "Cari",
    "all": "Semua",
    "loading": "Memuat...",
    "error": "Terjadi kesalahan",
    "notFound": "Tidak ditemukan",
    "tryAgain": "Silakan coba lagi",
    "retry": "Coba lagi",
    "undo": "Batalkan",
    "pullToRefresh": "Tarik untuk segarkan",
    "justNow": "baru saja"
  },
  "auth": {
    "welcome": "Selamat datang di FishMemory",
    "tagline": "Asisten pengingat WhatsApp Anda, kini di saku Anda.",
    "subtitle": "Asisten pengingat WhatsApp Anda, kini di saku Anda.",
    "phoneLabel": "Nomor WhatsApp Anda",
    "phoneHint": "Kami akan mengirim kode verifikasi via WhatsApp",
    "invalidPhone": "Masukkan nomor telepon yang valid",
    "continue": "Lanjutkan",
    "enterPhone": "Masukkan nomor WhatsApp Anda",
    "phonePlaceholder": "Nomor telepon",
    "sendCode": "Kirim Kode",
    "verifyTitle": "Verifikasi nomor Anda",
    "otpSentTo": "Kode 6 digit telah dikirim ke {{phone}} via WhatsApp",
    "enterFullCode": "Masukkan semua 6 digit",
    "invalidOtp": "Kode tidak valid. Silakan coba lagi.",
    "otpFailed": "Gagal mengirim kode. Coba lagi.",
    "otpResent": "Kode dikirim ulang",
    "resendIn": "Kirim ulang dalam {{seconds}}d",
    "resendCode": "Kirim ulang kode",
    "enterOtp": "Masukkan kode yang dikirim ke WhatsApp Anda",
    "verify": "Verifikasi",
    "resend": "Kirim ulang kode",
    "wrongNumber": "Nomor salah?",
    "backToPhone": "Kembali ke nomor",
    "editPhone": "Edit nomor telepon",
    "error": "Kesalahan",
    "setupTitle": "Mari atur semuanya",
    "setupSubtitle": "Anda bisa mengubahnya nanti di Pengaturan",
    "namePlaceholder": "Nama Anda",
    "letsGo": "Selesaikan pengaturan",
    "skipForNow": "Lewati dulu"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ketik pesan...",
    "inputPlaceholder": "Ketik pesan...",
    "typing": "FishMemory sedang mengetik...",
    "online": "Online",
    "connecting": "Menghubungkan...",
    "reconnecting": "Menyambung kembali...",
    "offline": "Offline",
    "empty": "Mulai percakapan",
    "emptyHint": "Buat pengingat, cek jadwal, atau minta bantuan.",
    "emptyAction": "Kirim pengingat contoh",
    "actions": "Aksi chat",
    "keep": "Simpan pesan",
    "clearTitle": "Bersihkan chat",
    "clearConfirm": "Hapus semua pesan dari perangkat ini? Tidak bisa dibatalkan.",
    "clear": "Bersihkan chat",
    "optionSelected": "Terpilih: {{label}}",
    "sendingSelection": "Mengirim...",
    "connectionLost": "Menyambung kembali..."
  },
  "reminders": {
    "title": "Pengingat Saya",
    "active": "Aktif",
    "today": "Hari Ini",
    "thisWeek": "Minggu Ini",
    "history": "Riwayat",
    "items": "item",
    "emptyTitle": "Belum ada pengingat",
    "emptySubtitle": "Buat dari chat dan akan muncul di sini.",
    "emptyAction": "Buka chat",
    "filterActive": "Aktif",
    "filterToday": "Hari Ini",
    "filterWeek": "Minggu Ini",
    "filterHistory": "Riwayat",
    "emptyState": "Belum ada pengingat. Mulai chat!",
    "swipeDone": "Selesai",
    "swipeSnooze": "Tunda",
    "swipeDelete": "Hapus",
    "search": "Cari pengingat...",
    "upcoming": "Akan datang",
    "completed": "Selesai",
    "overdue": "Terlambat",
    "tomorrow": "Besok",
    "synced": "Tersinkronisasi {{value}}",
    "swipeHint": "Geser pengingat untuk aksi lebih",
    "noResults": "Tidak ada pengingat cocok pencarian",
    "noResultsHint": "Coba kata kunci lain atau hapus pencarian",
    "deleteAllFailed": "Gagal menghapus semua pengingat"
  },
  "calendar": {
    "title": "Kalender",
    "today": "Hari Ini",
    "tomorrow": "Besok",
    "completed": "selesai",
    "noEvents": "Tidak ada jadwal",
    "noEventsSubtitle": "Pilih tanggal untuk lihat pengingat dan acara kalender.",
    "googleEvent": "Google Calendar",
    "legendActive": "Aktif",
    "legendRecurring": "Berulang",
    "legendDone": "Selesai",
    "legendGoogle": "Google",
    "previousMonth": "Bulan lalu",
    "nextMonth": "Bulan depan",
    "previousYear": "Tahun lalu",
    "nextYear": "Tahun depan",
    "goToToday": "Ke hari ini",
    "all": "Semua",
    "active": "Aktif",
    "done": "Selesai",
    "paused": "Jeda"
  },
  "settings": {
    "title": "Pengaturan",
    "profile": "Profil",
    "name": "Nama Tampilan",
    "enterName": "Masukkan nama Anda",
    "language": "Bahasa",
    "uiLanguage": "Bahasa aplikasi",
    "uiLanguageHelp": "Mengubah UI aplikasi, label kalender, dan arah tata letak hanya di perangkat ini.",
    "serverLanguage": "Bahasa chat",
    "serverLanguageHelp": "Mengubah bahasa balasan server dan pesan pengingat untuk akun Anda.",
    "timezone": "Zona waktu",
    "currentTimezone": "Zona waktu saat ini",
    "timezoneHelp": "Semua waktu pengingat ditampilkan menggunakan zona waktu ini.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Simpan zona waktu",
    "timezoneSaved": "Zona waktu diperbarui",
    "detect": "Deteksi",
    "detectFailed": "Gagal mendeteksi zona waktu",
    "autoDetect": "Deteksi otomatis dari GPS",
    "notifications": "Notifikasi",
    "notificationsHelp": "Pengingat lanjutan mengontrol peringatan berulang setelah pengingat dikirim. Izin notifikasi perangkat tetap diatur di pengaturan ponsel Anda.",
    "pushEnabled": "Notifikasi Push",
    "autoDoneOnFire": "Otomatis tandai selesai saat aktif",
    "autoDoneOnFireDesc": "Jika mati, pengingat tetap aktif sampai Anda tandai selesai.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Terhubung",
    "googleDisconnected": "Tidak terhubung",
    "googleConnectedHelp": "Pengingat baru dapat disinkronkan otomatis ke kalender Anda.",
    "googleDisconnectedHelp": "Hubungkan Google Calendar untuk menyelaraskan pengingat dan acara.",
    "googleConnectFailed": "Gagal menghubungkan Google Calendar",
    "connected": "Terhubung",
    "disconnected": "Tidak terhubung",
    "connect": "Hubungkan",
    "disconnect": "Putuskan",
    "autoSync": "Sinkron otomatis pengingat baru",
    "autosync": "Sinkron otomatis pengingat baru",
    "subscription": "Langganan",
    "trialUsed": "Percobaan: {{used}}/{{total}} digunakan",
    "trialStatus": "Percobaan tersedia",
    "activeStatus": "Langganan aktif",
    "expiredStatus": "Langganan kedaluwarsa",
    "unsubscribedStatus": "Tidak berlangganan",
    "about": "Tentang",
    "version": "Versi",
    "logout": "Keluar",
    "logoutTitle": "Keluar",
    "logoutConfirm": "Anda yakin ingin keluar?",
    "noName": "Nama belum diatur",
    "serverConnection": "Koneksi server",
    "serverUrl": "URL server",
    "serverEdit": "Edit",
    "saveReconnect": "Simpan dan sambungkan ulang",
    "resetDefault": "Reset default",
    "invalidServerUrlTitle": "URL server tidak valid",
    "invalidServerUrlMessage": "Masukkan URL server http atau https yang valid, misal https://example.com",
    "uiLanguageChangeFailed": "Gagal mengubah bahasa aplikasi. Silakan coba lagi.",
    "serverLanguageChangeFailed": "Gagal mengubah bahasa chat. Silakan coba lagi.",
    "timezoneChangeFailed": "Gagal mengubah zona waktu. Silakan coba lagi.",
    "autoSyncChangeFailed": "Gagal memperbarui sinkron otomatis. Silakan coba lagi.",
    "nameChangeFailed": "Gagal memperbarui nama tampilan. Silakan coba lagi.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detail pengingat",
    "editTime": "Ubah Waktu",
    "rename": "Ganti nama",
    "snooze": "Tunda",
    "snooze15": "Tunda 15 menit",
    "pause": "Jeda",
    "pauseReminder": "Jeda pengingat",
    "resume": "Lanjutkan",
    "resumeReminder": "Lanjutkan pengingat",
    "skip": "Lewati Berikutnya",
    "skipOccurrence": "Lewati kejadian ini",
    "syncGoogle": "Sinkron ke Google",
    "delete": "Hapus",
    "deleteTitle": "Hapus Pengingat",
    "deleteConfirm": "Pengingat ini akan dihapus permanen.",
    "deleteRecurringTitle": "Hapus Pengingat Berulang",
    "deleteRecurringMessage": "Ingin lewati kejadian ini atau hapus seluruh seri?",
    "deleteThisOccurrence": "Lewati Kejadian Ini",
    "deleteEntireSeries": "Hapus Seluruh Seri",
    "done": "Selesai",
    "markDone": "Tandai selesai",
    "undo": "Pulihkan",
    "undoPrompt": "Perlu aktif lagi? Pulihkan sekarang.",
    "recurring": "Berulang",
    "nextRun": "Jalankan berikutnya",
    "oneTime": "Sekali",
    "pending": "Menunggu",
    "sent": "Terkirim",
    "paused": "Dijeda",
    "active": "Aktif",
    "snoozed": "Ditunda",
    "localTime": "Ditampilkan dalam waktu lokal Anda",
    "recurrence": "Pengulangan",
    "created": "Dibuat",
    "tags": "Tag",
    "fireCount": "Jumlah aktif",
    "actions": "Aksi",
    "none": "Tidak ada",
    "snoozeFailed": "Gagal menunda pengingat",
    "pauseFailed": "Gagal menjeda pengingat",
    "resumeFailed": "Gagal melanjutkan pengingat",
    "skipFailed": "Gagal melewati pengingat",
    "doneFailed": "Gagal menandai pengingat selesai",
    "undoFailed": "Gagal memulihkan status pengingat",
    "deleteFailed": "Gagal menghapus pengingat",
    "rescheduleTitle": "Jadwal ulang?",
    "rescheduleMsg": "Pengingat ini terlambat. Ingin jadwal ulang?",
    "reschedule15": "Dalam 15 menit",
    "reschedule60": "Dalam 1 jam",
    "keepOverdue": "Biarkan seperti ini"
  },
  "onboarding": {
    "slide1Title": "Selamat datang di FishMemory",
    "slide1Sub": "Asisten pengingat pribadi Anda — didukung oleh WhatsApp dan dibuat untuk saku Anda.",
    "slide2Title": "Chat dengan alami",
    "slide2Sub": "Ketik pengingat seperti yang Anda pikirkan: \"Ingatkan saya telepon ibu besok jam 3 sore\" — kami urus sisanya.",
    "slide3Title": "Jangan pernah lupa",
    "slide3Sub": "Dapatkan notifikasi tepat waktu, atur dengan tag, dan tetap kendalikan semua yang penting.",
    "getStarted": "Mulai",
    "next": "Berikutnya",
    "firstReminderTitle": "Buat pengingat pertama Anda!",
    "firstReminderHint": "Coba ketik sesuatu seperti:",
    "firstReminderExample": "Ingatkan saya minum air besok jam 9 pagi",
    "gotIt": "Mengerti!",
    "notifRationaleTitle": "Tetap Tepat Waktu",
    "notifRationaleBody": "FishMemory butuh notifikasi untuk mengingatkan tepat waktu. Anda hanya akan dapat peringatan untuk pengingat yang Anda buat.",
    "notifRationaleAllow": "Aktifkan Notifikasi",
    "notifRationaleLater": "Nanti saja",
    "swipeHint": "Geser kanan untuk aksi cepat →",
    "calendarDragHint": "Seret untuk perbesar ↕"
  }
}
